module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/zh-hant/2-dfe29c91c7318b784fe663184355a8a5.jpg";